<script></script>
<template>
  <!--
     1. 检查是否已经登录， 没有登录跳转登录界面
     2. 登录成功以后回到首页
     3. 判断用户是否已经绑定，没有绑定提示绑定流程
     4. 展示列表数据
  -->
  <div class="container">
    <!--    <TitleBar :type=0 :listeners="listeners" :showRight="showRightButton"></TitleBar>-->
    <!--    <div @click="gotoSetting">设置</div>-->
    <div class="loading" v-if="loading">
      <img src="@/assets/loading.png" class="Rotation">
    </div>

    <div class="flex_vertial" v-if="!loading">
      <VipHead :vipInfo="vipInfo" :needAiOpen="needAiOpen" :outOfData="outOfData"
               :msgCount="calledList.totalRecord"></VipHead>
      <div class="list_title" v-if="calledList.totalRecord > 0">通话记录
        {{ calledList.totalRecord > 0 ? '(' + calledList.totalRecord + ')' : '' }}
      </div>
      <div class="notification_tips" v-if="showNotificationOpenTips && calledList.totalRecord > 0"
           @click="openNotification">
        <img class="hint_icon" src="@/assets/icon_hint.png">
        <div class="tips">助理无法通知你有新增来电</div>
        <img class="arch_icon" src="@/assets/icon_arch.png">
      </div>
      <CallList :calledList="calledList" id="calledList"></CallList>
      <CallList :calledList="exampleList" id="exampleList" v-on:delItem="delExampleItem"></CallList>

    </div>
  </div>

</template>

<script>
import {SERVICE_SWITCH} from '@/utils/const'
import app from '@/AppData'

const ENV = require('@/env.js')
import jsbridge from '@/jsbridge'
import util from '@/utils/util'
import exampleCallList from '@/utils/exampleCallList'

const TAG = '[index]'
import TitleBarStore from '@/components/widgets/TitleBarStore'

import luban from '../app.luban.sdk'
import VipHead from '@/components/widgets/VipHead'
import CallList from '@/components/widgets/CallList'
import TitleBar from '@/components/widgets/TitleBar'
import BasicSetting from './setting/BasicSetting'
import lubanapi from '@/lubanapi'

export default {
  name: 'Index',
  data () {
    var that = this
    return {
      loading: true,
      userInfo: {},
      vipInfo: {},
      calledList: {
        time: 0,
        isFinished: true,
        recordList: [],
        result: 0,
        totalRecord: 0,
        totalTime: 0,
      },
      userSetting: {},
      scrollTop: 0,
      isVip: false,
      needAiOpen: false,
      outOfData: false,
      scrollLoadingData: false,
      showNotificationOpenTips: false,
      exampleList: {},
      hasReportStatus: false
    }
  },
  components: {
    VipHead,
    CallList,
    TitleBar
  },
  created () {
    console.log(TAG, 'created')
  },
  mounted () {
    console.log(TAG, 'mounted')
    var that = this
    this.$nextTick(() => {
      document.getElementById('router-view').addEventListener('scroll', that.handelScroll)
    })
    lubanapi.reportseer('AICall_Home_Page_Shown')

    //
    this.exampleList = exampleCallList.getCallList()
  },

  deactivated () {
    console.log(TAG, 'deactivated', this.scrollTop)
    sessionStorage.setItem('IndexListScrollTop', this.scrollTop)
  },

  activated () {
    console.log(TAG, 'activated', this.vipInfo)

    TitleBarStore.store.hideBack()
    TitleBarStore.store.showRight()
    // TitleBarStore.store.changeBackGround('red')
    if (this.vipInfo.vipStatus === 1) {
      TitleBarStore.store.changeWhiteText(true)
      TitleBarStore.store.setHeadStyle(1)
      this.isVip = true
    } else {
      TitleBarStore.store.changeWhiteText(true)
      TitleBarStore.store.setHeadStyle(2)
    }

    if (app.getLocalStorage(SERVICE_SWITCH.NAME) === SERVICE_SWITCH.STATE_CLOSE) {
      this.needAiOpen = true
      lubanapi.reportseer('AICall_Home_Page_Shown_Service_Close')
    } else {
      this.needAiOpen = false
    }

    var that = this
    this.$nextTick(() => {
      that.scrollTop = sessionStorage.getItem('IndexListScrollTop')
      document.getElementById('router-view').scrollTop = that.scrollTop
    })

    if (this.calledList.recordList.length !== 0) {
      this.calledList = app.getData().calledList
    }

    app.initBaseData(true).then(res => {
      if (!app.getData().userSetting
        || app.getData().userSetting.phoneNum === '') {
        // 跳转绑定页面
        console.log('needBind', app.getData().userSetting)
        that.$router.push({
          path: '/bind_guide'
        })
      } else {
        // 开始加载数据
        console.log('login success and hasBindBum')

        // 不重复拉取
        if (this.calledList.totalRecord === 0 || app.getData().needRefreshCalledList) {
          this.scrollLoadingData = true
          app.getCalledList().then(res => {
            // console.log("getCalledList", res)
            this.scrollLoadingData = false
            this.init()
            this.updateTags()
            this.updateContacts()
            this.reportStatus()
          }).catch(err => {
            console.log('err', err)
            this.scrollLoadingData = false
          })
        } else {
          this.init()
        }

        // 拉自定义信息
        if (app.isVip()) {
          app.getOpeningRemark().then(value => {
            console.log('getOpeningRemark success, value:' + JSON.stringify(value))
            app.setUserCustomContent(value)
          }, reason => {
            console.log('getOpeningRemark fail, reason:' + JSON.stringify(reason))
          })
          app.fetchSceneReplyData().then(value => {
            console.log('fetchSceneReplyData success, value:' + JSON.stringify(value))
            app.setSceneReplyData(value)
          }, reason => {
            console.log('fetchSceneReplyData fail, reason:' + JSON.stringify(reason))
          })
        }
      }
    }).catch(err => {
      console.log('err', err)
    })

    jsbridge.checkNotificationPermission().then(res => {
      if (res == 0) {
        this.showNotificationOpenTips = true
      } else {
        this.showNotificationOpenTips = false
      }
    })
  },

  methods: {

    updateTags () {
      var that = this
      app.updateCallListTag().then(res => {
        let {
          calledList
        } = app.getData()

        that.commit({
          calledList,
        })

        // 强制刷新列表
        this.calledList.recordList.splice(this.calledList.recordList.length)
        console.log(TAG, 'updateTags', res)
      }).catch(err => {
        console.log(TAG, 'updateTags', err)
      })
    },

    updateContacts () {
      app.updateCallListContacts().then(res => {
        console.log(TAG, 'updateContacts', res)
        let {
          calledList
        } = app.getData()

        this.commit({
          calledList,
        })

        // 强制刷新列表
        this.calledList.recordList.splice(this.calledList.recordList.length)
      }).catch(err => {
        console.log(TAG, 'updateContacts', err)
      })
    },

    reportStatus () {
      if (!this.hasReportStatus) {
        this.hasReportStatus = true
        if (!this.isVip) {
          if (this.calledList.recordList.length < 3) {
            lubanapi.reportseer('AICall_Home_Page_Shown_Not_Member_Can_Try')
          } else {
            lubanapi.reportseer('AICall_Home_Page_Shown_Not_Member_Can_Not_Try')
          }
        } else {
          lubanapi.reportseer('AICall_Home_Page_Shown_Member_Within_Period')
        }
      }
    },

    gotoSetting () {
      this.$router.push({
        path: '/basic_setting'
      })
    },

    loadMore () {
      if (!this.scrollLoadingData && !this.calledList.isFinished && this.calledList.totalRecord > this.calledList.recordList.length) {
        let startTime = this.calledList.recordList[this.calledList.recordList.length - 1].startTime * 1000 - 1
        this.scrollLoadingData = true
        app.getCalledList(startTime, true).then(calledListRes => {
          this.scrollLoadingData = false
          this.init()
          this.updateTags()
          this.updateContacts()
        }).catch(err => {
          console.log('loadmore', err)
          this.scrollLoadingData = false
        })
      }
    },

    handelScroll () {
      var scrollList = document.getElementById('router-view')
      this.scrollTop = scrollList.scrollTop
      // console.log(TAG, 'scrollTop')
      // console.log(TAG,  this.scrollTop, this)

      //
      let scrollTop = scrollList.scrollTop
      let clientHeight = scrollList.clientHeight
      let scrollHeight = scrollList.scrollHeight
      if (scrollTop + clientHeight >= scrollHeight) {
        console.log('滑到底了')
        this.loadMore()
      }
    },

    init () {
      let {
        userInfo,
        userSetting,
        vipInfo,
        calledList
      } = app.getData()

      this.commit({
        userInfo,
        vipInfo,
        userSetting,
        calledList,
        loading: false,
      })

      if (app.isLimitRead()) {
        this.outOfData = true
      } else {
        this.outOfData = false
      }

      if (app.isVip()) {
        TitleBarStore.store.changeWhiteText(true)
        TitleBarStore.store.setHeadStyle(1)
      } else {
        TitleBarStore.store.changeWhiteText(true)
        TitleBarStore.store.setHeadStyle(2)
      }
    },
    commit (data) {
      Object.keys(data).forEach(key => {
        console.log(TAG, 'key', key, data[key])
        this[key] = data[key]
      })
    },

    openNotification () {
      this.showNotificationOpenTips = false
      jsbridge.openNotificationPermission()
    },

    delExampleItem (item) {
      exampleCallList.delRecord(item)
      this.exampleList = exampleCallList.getCallList()
    },

    test () {
      // var nums = ['10010', '18620058240', '+8618620058240','13535454074']
      // jsbridge.searchNums(nums).then(res => {})
      // jsbridge.setAiRedirectCall('18620058240').then(res =>{})
    }
  }
}
</script>
<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>

.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 121;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading img {
  width: 20%;
  z-index: 999;
}

.list_title {
  height: 1.2rem;
  font-family: PingFangSC-Regular;
  font-size: 0.8rem;
  color: #000000;
  letter-spacing: 0;
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 0.2rem;
  text-align: left;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  box-sizing: border-box;
  background: white;
}

.container {
  width: 100%;
}

.notification_tips {
  width: calc(100% - 1.6rem);
  height: 2.2rem;
  background-image: linear-gradient(-48deg, #F1BE5F 0%, #FF8442 100%);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.notification_tips .hint_icon {
  width: 1.315rem;
  height: 1.315rem;
  margin-left: 0.8rem;
  margin-right: 0.8rem;
}

.notification_tips .tips {
  flex: 1;
  font-family: PingFangSC-Regular;
  font-size: 0.875rem;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: left;
}

.notification_tips .arch_icon {
  width: 0.315rem;
  height: 0.695rem;
  margin-right: 0.8rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue